function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.333 14.667C23.5463 14.667 25.3197 12.8803 25.3197 10.667C25.3197 8.45366 23.5463 6.66699 21.333 6.66699C19.1197 6.66699 17.333 8.45366 17.333 10.667C17.333 12.8803 19.1197 14.667 21.333 14.667ZM10.6663 14.667C12.8797 14.667 14.653 12.8803 14.653 10.667C14.653 8.45366 12.8797 6.66699 10.6663 6.66699C8.45301 6.66699 6.66634 8.45366 6.66634 10.667C6.66634 12.8803 8.45301 14.667 10.6663 14.667ZM10.6663 17.3337C7.55967 17.3337 1.33301 18.8937 1.33301 22.0003V24.0003C1.33301 24.7337 1.93301 25.3337 2.66634 25.3337H18.6663C19.3997 25.3337 19.9997 24.7337 19.9997 24.0003V22.0003C19.9997 18.8937 13.773 17.3337 10.6663 17.3337ZM21.333 17.3337C20.9463 17.3337 20.5063 17.3603 20.0397 17.4003C20.0663 17.4137 20.0797 17.4403 20.093 17.4537C21.613 18.5603 22.6663 20.0403 22.6663 22.0003V24.0003C22.6663 24.467 22.573 24.9203 22.4263 25.3337H29.333C30.0663 25.3337 30.6663 24.7337 30.6663 24.0003V22.0003C30.6663 18.8937 24.4397 17.3337 21.333 17.3337Z",
  fill: "white"
});

const SvgTeams = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTeams, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/teams.1462f1c2.svg";
export { ForwardRef as ReactComponent };